import React from 'react';
import { DynamicFormDto } from '@hqo/dynamic-forms-sdk/types';

export const FormDefinitionDto = React.createContext<DynamicFormDto>(undefined);
